import { List } from "components";
import React from "react";
import { ActualVsExtendedChart } from "../slippage/components/actual-vs-extended-chart";
import {
  NameCell,
  DateCell,
  StatusCell,
  ExtensionCell,
  AmountCell,
} from "./cells";
import ReportBillableFilters from "./filters";
import { ProjectCell, JobCell } from "@/modules/work/billables/cells";
import { ROUTE } from "@/lib/utils";
import { BillableNameCell } from "@/modules/work/billables/cells";
import { EmployeeCell } from "components/cell/employee/cell";
import { usePermissions } from "contexts/permission";

export default function BillablesExtensionsReports() {
  const permissions = usePermissions();

  const canReadAmount = permissions.hasFieldAccess(
    "billables",
    "read",
    "amount",
  );

  const baseFields = [
    "id",
    "name",
    "type",
    "job.name",
    "job.project.name",
    "status",
    "billing_date",
    "due_date",
    "extensions.start_date",
    "extensions.billing_date",
    // company name under project -> client -> company
    {
      job: [
        {
          project: ["client.company_id.name"],
        },
      ],
    },
    {
      job: [
        "id",
        "coordinator.id",
        "coordinator.avatar",
        "coordinator.first_name",
        "coordinator.last_name",
        {
          project: [
            "id",
            "name",
            "coordinator.id",
            "coordinator.avatar",
            "coordinator.first_name",
            "coordinator.last_name",
            "account_manager.id",
            "account_manager.avatar",
            "account_manager.first_name",
            "account_manager.last_name",
            "sales_coordinator.id",
            "sales_coordinator.avatar",
            "sales_coordinator.first_name",
            "sales_coordinator.last_name",
            "project_id",
          ],
        },
      ],
    },
  ];

  const fields = [
    ...baseFields,
    ...(canReadAmount ? ["amount", "currency.name", "adjusted_amount"] : []),
  ];

  const columns = [
    {
      id: "name",
      header: "Billable",
      accessorKey: "name",
      cell: BillableNameCell,
    },
    {
      id: "job",
      header: "Job",
      accessorKey: "job.name",
      cell: JobCell,
    },
    {
      id: "status",
      header: "Status",
      accessorKey: "status",
      cell: StatusCell,
    },
    {
      id: "job.project.name",
      header: "Project",
      accessorKey: "job.project.name",
      cell: ProjectCell,
    },
    {
      id: "company",
      header: "Company",
      accessorKey: "job.project.client.company_id.name",
    },
    {
      id: "amount",
      header: "Amount",
      accessorKey: "amount",
      cell: AmountCell,
      field: "amount",
    },
    {
      id: "billing_date_actual",
      header: "Billing Date",
      sortable: true,
      cell: ({ row }) =>
        DateCell({
          getValue: () => row?.original?.extensions?.[0]?.start_date ?? null,
        }),
    },
    {
      id: "billing_date",
      header: "Extended Date",
      accessorKey: "billing_date",
      sortable: true,
      cell: DateCell,
    },
    {
      id: "extensions",
      header: "Extended",
      accessorKey: "extensions",
      cell: ExtensionCell,
    },
    {
      id: "extensions_count",
      accessorKey: "extensions",
      header: "Extensions Count",
      cell: ({ getValue }) => getValue().length,
    },
    {
      id: "job.project.coordinator",
      header: "PC",
      accessorKey: "job.project.coordinator",
      cell: EmployeeCell,
    },
    {
      id: "job.project.account_manager",
      header: "AM",
      accessorKey: "job.project.account_manager",
      cell: EmployeeCell,
    },
    {
      id: "job.project.sales_coordinator",
      header: "SC",
      accessorKey: "job.project.sales_coordinator",
      cell: EmployeeCell,
    },
  ];

  const defaultFilters = {
    extensions: { _nnull: true },
    status: { _eq: "billed" },
  };

  const deep = {
    extensions: {
      _sort: ["date_created"],
    },
  };

  return (
    <div className="flex-1 flex flex-col overflow-auto">
      <div className="flex-1 overflow-auto">
        <List
          title="Extended Billables"
          storageKey="billables-extensions"
          endPoint="billables"
          filters={defaultFilters}
          columns={columns}
          meta={{ fields, deep }}
          // href={(item) => ROUTE.BILLABLE_EXTENSIONS(item.id)}
          href={null}
          renderFilters={ReportBillableFilters}
          sortBy="billing_date"
          sortOrder="asc"
        />
      </div>
    </div>
  );
}
